<p-inputGroup>
  <input pInputText
         placeholder="{{'utils.search' | translate}}"
         [attr.data-testid]='dataCy || null'
         [value]='value()'
         (input)='search($any($event.target).value)' data-testid="input">
  @if(showClearWhenInputEmpty()) {
    <button pButton icon="fa fa-x" (click)="search('')" data-testid="search-btn"></button>
  }
</p-inputGroup>


